import * as React from "react";
import "./CollectionCard.css";
import cn from "classnames";

interface Props {
	header: string;
	imageURL?: string;
	action: (() => void) | string;
	isSelected?: boolean;
}

const CollectionCard: React.FunctionComponent<Props> = (props) => {
	const cardRender = () => {
		return <div
			className={cn("card", { card_selected: props.isSelected })}
			onClick={typeof props.action === "function" ? props.action : () => {}}
			style={{
				backgroundImage: `url(${props.imageURL})`,
			}}
		>
			<div className="card__header">{props.header}</div>
		</div>;
	};

	return typeof props.action === "string" ? <a className="card__link" href={props.action}>
		{cardRender()}
	</a> : <div className="card__link">{cardRender()}</div>;
};

export default CollectionCard;
